import { BET_NEVER_REMIND } from "./key";

export default {
  [BET_NEVER_REMIND]: {
    type: Boolean,
    default: false,
  },
};
